const stadistics = {
  backbtn: "Atrás",
  pumpHousingC: "Temperatura de la carcasa de la bomba (°C)",
  pumpHousingF: "Temperatura de la carcasa de la bomba (°F)",
  mapCFSBar11: "API 11 Presión del Out Board y In Board (bar)",
  mapSHTc: "API 23 Temperatura de la cámara de sellado (°F)",
  mapSHPbar: "Presión de la cámara de sellado API 23 (bar)",
  mapFITc: "API 23 FI Temperatura (°C)",
  mapCwTc:
    "API 23 Temperatura de entrada y salida del agua de enfriamiento (° C)",
  mapfCTc: "API 32 Temperatura del Out Board y In Board (°C)",
  mapfCbar: "API 32 Presión del Out Board y In Board (bar)",
  mapCwInOut52:
    "API 52 Temperatura de entrada y salida del agua de enfriamiento (°C)",
  mapOilInOut52: "API 52 Temperatura del aceite (°C) dentro y fuera",
  mapShPbar52: "API 52 Presión de la caja de relleno (bar)",
  mapPBar52: "API 52 Presión (bar)",
  mapTankLevel52: "API 52 Nivel de Tanque (mm)",
  mapIaPbar53b: "API 53b Instrumento Presión de Aire (bar)",
  mapSysPbar53b: "Presión del sistema API 53b (bar)",
  mapcBpiBpoTc53b: "API 53b Temperatura de Bpi Bpo del In Board   (° C)",
  mapfBpiBpoTc53b: "API 53b Temperatura de Bpi Bpo del Out Board  (° C)",
  mapcBpiBpoBar53b: "API 53b Presión de Bpo del Out Board y In Board (Bar)",
  mapfBpiBpoBar53b: "API 53b Presión de Bpi Bpo Out Board (Bar)",
  mapcCwInOut53b:
    "API 53b Temperatura de entrada y salida de agua de enfriamiento acoplada (° C)",
  mapfCwInOut53b:
    "API 53b Temperatura de entrada y salida del agua de enfriamiento Out Board (° C)",
  mapFCRs53b:
    "Sistemas de recarga API 53b In Boards y Out Boards - Presión (bar)",
  mapBpiBpoTc54: "API 54 Temperatura de BPI - BPO del In Board (° C)",
  mapBpiBpoPbar54: "API 54 Presion de BPI - BPO en el In Board (bar)",
  mapCwInOut54:
    "API 54, temperatura de entrada y salida del agua de enfriamiento del In Board (° C)",
  mapFlowL54: "Flujo del In Board API 54 (l / min)",
  mapMotorTc54: "API 54 Temperatura del motor del In Board (° C)",
  mapTankLevel54: "Nivel de tanque lateral In Board API 54 (mm)",
  mapfBpiBpoTc54: "API 54 Temperatura de BPI - BPO del Out Board (° C)",
  mapfBpiBpoPbar54: "API 54 Presion de BPI - BPO del Out Board (bar)",
  mapfCwInOut54:
    "API 54 Temperatura de entrada y salida del agua de enfriamiento del Out Board (° C)",
  mapfFlowL54: "API 54 Flujo del Out Board  (l / min)",
  mapfMotorTc54: "API 54 Temperatura del motor del Out Board (° C)",
  mapfTankLevel54: "Nivel de tanque del Out Board API 54 (mm)",
  imapPumpHousing: "Temperatura de la carcasa de la bomba (° F)",
  imapCFSpsi11: "API 11 Presión del Out Board y In Board (psi)",
  imapSHTc: "Temperatura de la cámara de selladoAPI 23 (° F)",
  imapSHPbar: "Presión de la cámara de sellado API 23 (psi)",
  imapFITc: "Temperatura API 23 FI (° F)",
  imapCwTc:
    "API 23 Temperatura de entrada y salida del agua de enfriamiento (° F)",
  imapfCTf: "API 32 Temperatura del Out Board y In Board (° F)",
  mapfCpsi: "API 32 Presión del Out Board y In Board (psi)",
  imapCwInOut52:
    "API 52 Temperatura de entrada y salida del agua de enfriamiento (° F)",
  imapOilInOut52: "API 52 Temperatura del aceite (° F) dentro y fuera",
  imapShPbar52: "API 52 Presión de la caja de relleno (psi)",
  imapPBar52: "Presión API 52 (psi)",
  imapTankLevel52: "API 52 Nivel de tanque (mm)",
  imapIaPbar53b: "API 53b Instrument Air Pressure (psi)",
  imapSysPbar53b: "Presión del sistema API 53b (psi)",
  imapcBpiBpoTc53b: "API 53b temperatura de Bpi Bpo acoplada (° F)",
  imapfBpiBpoTc53b: "API 53b Out Board Bpi Bpo Temperatura (° F)",
  imapcBpiBpoBar53b: "API 53b Presión de Bpo del Out Board y In Board (psi)",
  imapfBpiBpoBar53b: "API 53b Out Board Bpo Pressure (psi)",
  imapcCwInOut53b:
    "Temperatura de entrada y salida de agua de enfriamiento acoplada API 53b (° F)",
  imapfCwInOut53b:
    "API 53b Temperatura de entrada y salida del agua de enfriamiento Out Board (° F)",
  imapFCRs53b:
    "Sistemas de recarga API 53b In Boards y Out Boards - Presión (psi)",
  imapBpiBpoTc54: "API 54 temperatura del In Board BPI y BPO (° F)",
  imapBpiBpoPbar54: "API 54 In Board BPI - presión BPO (psi)",
  imapCwInOut54:
    "Temperatura de entrada y salida del agua de enfriamiento del In Board API 54 (° F)",
  imapFlowL54: "Flujo lado acomplado API 54 (gal / min)",
  imapMotorTc54: "API 54 Temperatura del motor del In Board (° F)",
  imapTankLevel54: "Nivel de tanque In Board API 54 (l)",
  imapfBpiBpoTc54: "API 54 Temperatura de BPI - BPO del Out Board (° F)",
  imapfBpiBpoPbar54: "API 54 Presion de BPI - BPO en el Out Board (PSI)",
  imapfCwInOut54:
    "API 54 temperatura del agua de enfriamiento del Out Board de entrada y salida (° F)",
  imapfFlowL54: "API 54 Flujo del Out Board (gal / min)",
  imapfMotorTc54: "API 54 Temperatura del motor del Out Board (° F)",
  imapfTankLevel54: "API 54 Nivel de tanque del Out Board (l)",
  commentList: "Lista de comentarios",
  inspectionDate: "Fecha de inspección",
  comment: "Comentario"
};
export default stadistics;
